export default "__VITE_ASSET__DR62thht__"